import { render, staticRenderFns } from "./UserInfoButton.vue?vue&type=template&id=37e0f3f2"
import script from "./UserInfoButton.vue?vue&type=script&lang=js"
export * from "./UserInfoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports